import {
  ManualVerificationFormType,
  VerifyInsuranceFormType
} from './EligibilityVerificationFromType';
import moment from 'moment';
export const verifyInsuranceValidation = (
  values: VerifyInsuranceFormType
): Partial<
  Record<keyof VerifyInsuranceFormType, { type: string; message: string }>
> => {
  const errors: Partial<
    Record<keyof VerifyInsuranceFormType, { type: string; message: string }>
  > = {};
  if (!values.insurance_name || !values.insurance_name.trim()) {
    errors.insurance_name = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.VERIFY_INSURANCE_FORM.VALIDATORS.INSURANCE_NAME_REQUIRED'
    };
  }
  if (!values.group_number || !values.group_number.trim()) {
    errors.group_number = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.VERIFY_INSURANCE_FORM.VALIDATORS.SUBSCRIBER_GROUP_NUMBER_REQUIRED'
    };
  }
  if (!values.member_id || !values.member_id.trim()) {
    errors.member_id = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.VERIFY_INSURANCE_FORM.VALIDATORS.SUBSCRIBER_MEMBER_ID_REQUIRED'
    };
  }
  if (!values.insurance_type || !values.insurance_type.trim()) {
    errors.insurance_type = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.VERIFY_INSURANCE_FORM.VALIDATORS.INSURANCE_TYPE_REQUIRED'
    };
  }
  return errors;
};

export const manualVerificationValidation = (
  values: ManualVerificationFormType
): Partial<
  Record<keyof ManualVerificationFormType, { type: string; message: string }>
> => {
  const errors: Partial<
    Record<keyof ManualVerificationFormType, { type: string; message: string }>
  > = {};
  const startDateMomentObj = moment(values.plan_start_date);
  const endDateMomentObj = moment(values.plan_end_date);

  if (!values.insurance_name || !values.insurance_name.trim()) {
    errors.insurance_name = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INSURANCE_NAME_REQUIRED'
    };
  }
  if (!values.subscriber_member_id || !values.subscriber_member_id.trim()) {
    errors.subscriber_member_id = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.SUBSCRIBER_MEMBER_ID_REQUIRED'
    };
  }
  if (
    !values.subscriber_group_number ||
    !values.subscriber_group_number.trim()
  ) {
    errors.subscriber_group_number = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.SUBSCRIBER_GROUP_NUMBER_REQUIRED'
    };
  }
  if (!values.plan_name || !values.plan_name.trim()) {
    errors.plan_name = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.PLAN_NAME_REQUIRED'
    };
  }
  if (!values.plan_start_date) {
    errors.plan_start_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.PLAN_START_DATE_REQUIRED'
    };
  } else if (!startDateMomentObj.isValid()) {
    errors.plan_start_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INVALID_DATE'
    };
  } else if (
    endDateMomentObj.isValid() &&
    startDateMomentObj.isAfter(endDateMomentObj)
  ) {
    errors.plan_start_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INVALID_PLAN_START_DATE'
    };
  }

  if (!values.plan_end_date) {
    errors.plan_end_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.PLAN_END_DATE_REQUIRED'
    };
  } else if (!endDateMomentObj.isValid()) {
    errors.plan_end_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INVALID_DATE'
    };
  } else if (
    startDateMomentObj.isValid() &&
    startDateMomentObj.isAfter(endDateMomentObj)
  ) {
    errors.plan_end_date = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INVALID_PLAN_END_DATE'
    };
  }

  if (!values.policy_number || !values.policy_number.trim()) {
    errors.policy_number = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.POLICY_NUMBER_REQUIRED'
    };
  }
  if (!values.plan_number || !values.plan_number.trim()) {
    errors.plan_number = {
      type: 'required',
      message:
        'ELIGIBILITY_VERIFICATION.MANUAL_VERIFY_INSURANCE_FORM.VALIDATORS.INSURANCE_TYPE_REQUIRED'
    };
  }
  return errors;
};
